import { useQuery } from '@tanstack/react-query';

import { EventFieldOptions, ProblemDetails, EventReportClient, ReportType } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const incidentClient = new EventReportClient(apiBaseUrl);

function useGetEventReportFieldOptions(reportType: ReportType) {
  return useQuery<EventFieldOptions, ProblemDetails>({
    queryKey: [queryKeys.Incident.FieldOptions],
    queryFn: () => incidentClient.getFieldOptions(reportType),
    initialData: {} as EventFieldOptions,
  });
}

export default useGetEventReportFieldOptions;
